import { type GasPureScreenEventPayload } from '@atlaskit/analytics-gas-types';

type BulkConenctModalShownAnalyticsProps = {
	commonAttributes: Record<string, any>;
};

export const onBulkConenctModalShown = ({
	commonAttributes,
}: BulkConenctModalShownAnalyticsProps): GasPureScreenEventPayload => {
	return {
		name: '3pBulkConnectModal',
		attributes: {
			...commonAttributes,
		},
	};
};
